<app-gallery-related-office [relatedOffice]="relatedOffice" *ngIf="showRelatedOffice && relatedOffice"></app-gallery-related-office>
<div class="top-info">
  <div class="filters is-flex" style="line-height: 34px">
    <div class="flex-one">
      <span class="has-pos-rel listings-count" translate="gallery.listings-count" [translateParams]="{pageCount: showingListings.length}">
      </span>
      <span *ngIf="isPaginated">
        {{ 'gallery.listings-of' | translate: {total: showOnlySelectedCluster ? showSpecificListings.length : listOfSortedFakeListings.length} }}
      </span>
    </div>
    <div class="flex-one">
      <form [formGroup]="sortForm">
        <app-select id="galleryViewDesktop-select-sortListings" [options]="sortOptions" [formControl]="sortForm.get('sort')" [parentFormGroup]="sortForm"></app-select>
      </form>
    </div>
  </div>
</div>

<div class="gallery-container-desktop flex-one" #galleryContainer>
  <div #container class="gallery-container full-width is-flex">
    <app-listing-card
      *ngFor="let listing of showingListings; trackBy: Listing.trackBy"
      [listing]="listing"
      [isSelectedCard]="true"
      (onHoverListingCard)="onHoverListingCard($event)"
      (click)="onGalleryCardClicked(listing)">
    </app-listing-card>
    <!-- Need this to accommodate for padding of space to ensure left alignment of cards -->
    <div class="invisible-box"></div>
    <div class="invisible-box"></div>
    <div class="invisible-box"></div>
    <div class="invisible-box"></div>
  </div>
  <app-pagination [totalPages]="pagination.totalPages" [currentPageNumber]="pagination.pageNumber"
  (onChangePage)="changePage($event)"></app-pagination>
  <app-logo></app-logo>
  <ng-content></ng-content>
</div>

<app-panel-message *ngIf="!isDoneFetchingListings && activeViewMode === ViewModes.GALLERY">
  <h4 translate="panel-message.getting-listings"></h4>
  <img [src]="('/assets/gifs/image-loader.gif' | staticp)" alt="{{'panel-message.loading-icon' | translate}}"/>
</app-panel-message>
